module.exports = __webpack_public_path__ + "static/media/details-11-image-1.b44e0488.jpg";